import React, { useContext } from 'react';

import { FetchContext } from '../../../../contexts';
import { useAggregatedState } from '../../../../../helpers';

export const IdentificationContext = React.createContext(null);

const { Provider } = IdentificationContext;
export const IdentificationProvider = (props) => { 
    const [state, setState] = useAggregatedState({
    });

    return (
        <Provider value={{
            state
        }}>
            {props.children}
        </Provider>
    );
}